var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedirects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 80,
    viewBox: "0 0 216 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.634 13.996 76 13.526v20.349h59.92V42.5L160 23.846 150.234 16H183c3.866 0 7 3.582 7 8s-3.134 8-7 8h22c3.866 0 7 3.582 7 8s-3.134 8-7 8h-19c-3.866 0-7 3.582-7 8s3.134 8 7 8h6c3.866 0 7 3.582 7 8s-3.134 8-7 8h-52a6.186 6.186 0 0 1-1.5-.184c-.483.12-.985.184-1.5.184H46c-3.866 0-7-3.582-7-8s3.134-8 7-8H7c-3.866 0-7-3.582-7-8s3.134-8 7-8h40c3.866 0 7-3.582 7-8s-3.134-8-7-8H22c-3.866 0-7-3.582-7-8s3.134-8 7-8h40c-3.866 0-7-3.582-7-8s3.134-8 7-8h57c3.866 0 7 3.582 7 8 0 2.387-.915 4.53-2.366 5.996ZM209 80c-3.866 0-7-3.582-7-8s3.134-8 7-8 7 3.582 7 8-3.134 8-7 8Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#6A6666",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.903 76h-90.56 98.31-99.428H170h-11.097Zm-98.412 0H46h14.491Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 36.5v37.14",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M76.5 14.5v20M135.444 14.27l-58.888.05M135.444 34.086H76.556M135.5 42.655v-8M135.5 13.655v-9M160 23.944 135.568 4.655M160 24.056l-24.432 18.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 35.928v38.889",
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirects);
export default __webpack_public_path__ + "static/media/redirects.46211ab590acb705c4e1a7b1079bceca.svg";
export { ForwardRef as ReactComponent };